import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GetQuoteComponent } from './get-quote/get-quote.component';
import { QuotationPremiumComponent } from './quotation-premium/quotation-premium.component';
import { ProposalFormComponent } from './proposal-form/proposal-form.component';
import { MyQuotationComponent } from './my-quotation/my-quotation.component';
import { CompareProductComponent } from './compare-product/compare-product.component';
import { authGuard } from 'src/app/core/guards/auth.guard';
import { CompareProductWhatsappComponent } from './compare-product-whatsapp/compare-product-whatsapp.component';
import { ProposalFormV1Component } from './proposal-form-v1/proposal-form-v1.component';


const routes: Routes = [
  { path: '', redirectTo: 'get-quote', pathMatch: 'full' },
  { path: 'get-quote', component: GetQuoteComponent },
  { path: 'get-quote/:quotationId', component: GetQuoteComponent },
  { path: 'quotation-premium/:quotationId', component: QuotationPremiumComponent },
  { path: 'proposal-form/:quotationId/:quotesId', component: ProposalFormV1Component , canActivate: [authGuard]},
  { path: 'proposal-form-v1/:quotationId/:quotesId', component: ProposalFormComponent , canActivate: [authGuard]},
  { path: 'my-quotation', component: MyQuotationComponent, canActivate: [authGuard] },
  { path: 'compare-product/:quotationId', component: CompareProductComponent },
  { path: 'compare-product-whatsapp/:quotationId', component: CompareProductWhatsappComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuotationRoutingModule { }
